
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { testValueType } from './test.mjs.js';
import { auto } from './type-auto.mjs.js';
import { number } from '../../../../../../style-value-types/dist/es/numbers/index.mjs.js';
import { px, percent, degrees, vw, vh } from '../../../../../../style-value-types/dist/es/numbers/units.mjs.js';

/**
 * A list of value types commonly used for dimensions
 */
var dimensionValueTypes = [number, px, percent, degrees, vw, vh, auto];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */
var findDimensionValueType = function (v) {
    return dimensionValueTypes.find(testValueType(v));
};

export { dimensionValueTypes, findDimensionValueType };
//# sourceMappingURL=dimensions.mjs.js.map
